module.exports = __webpack_public_path__ + "img/3bg.3dfac4b3.png";